import { starRatingBarSizes, starRatingBarSizesInPx } from '../constants';
import { StarsRatingBarProps } from '../StarsRatingBar.types';

export const getRatingLabel = (
  { labelValues }: StarsRatingBarProps,
  starValue: number,
) => {
  return labelValues?.[starValue - 1] ?? String(starValue);
};

export const getStarSizePx = ({ readOnly, size }: StarsRatingBarProps) => {
  let resolvedSize;

  if (readOnly) {
    resolvedSize = size ?? starRatingBarSizes.medium;
  } else {
    resolvedSize =
      size === starRatingBarSizes.medium
        ? starRatingBarSizes.medium
        : starRatingBarSizes.large;
  }

  return starRatingBarSizesInPx[resolvedSize];
};
